import SocketFactory from '@/drivers/socket'
import { loadImage } from '@/utils/load-image'

import type { PrinterConfig, PrinterDriver } from '../types'
import StarGraphicEncoder from './star-graphic-encoder'

export default class StarGraphic implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  printImage(imageData: string) {
    return new Promise<void>((resolve, reject) => {
      const rejectMiddleware = (error: unknown) => {
        reject(error)
      }
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        async () => {
          const img = await loadImage(imageData)
          const width = 576
          const ratio = width / img.width
          const height = Math.round((img.height * ratio) / 8) * 8

          const encoder = new StarGraphicEncoder()
          const result = encoder.initialize().image(img, width, height).cut().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, rejectMiddleware)
            },
            rejectMiddleware
          )
        },
        rejectMiddleware
      )
    })
  }

  openCashDrawer() {
    return new Promise<void>((resolve, reject) => {
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        () => {
          const encoder = new StarGraphicEncoder()
          const result = encoder.initialize().openCashDrawer().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, reject)
            },
            reject
          )
        },
        reject
      )
    })
  }
}
